import { useExperiments } from '../experiments/experimentsQueries';
const experimentId = 'acad-0004';
/**
 * Recency offset: dictates the time window at which we keep the multiplier at 1 before starting to decay. Values between 24H and 72H
 * Recency scale: dictates the time window from which we decay from 1 to 0.5. We will always decay to 0.5, never below. Values between 72H and 168H
 * Recency decay: dictates how aggressively we decay. Values between 0.5 and 0.7
 */
export const SearchRecencyConfigExperimentParams = {
  control: {
    recencyOffset: 'PT72H0M',
    recencyScale: 'PT72H0M',
    recencyDecay: 0.7
  },
  variation1: {
    recencyOffset: 'PT1440H0M',
    recencyScale: 'PT72H0M',
    recencyDecay: 0.7
  },
  variation2: {
    recencyOffset: 'PT2160H0M',
    recencyScale: 'PT72H0M',
    recencyDecay: 0.7
  }
};
const baseConfiguration = {
  nameBoost: 50,
  descriptionBoost: 25,
  professorsBoost: 10,
  introContentNameBoost: 15,
  introContentDescriptionBoost: 7.5,
  introContentBoost: 5,
  subContentNamesBoost: 12,
  subContentDescriptionsBoost: 6,
  subContentsBoost: 1.5,
  categoriesBoost: 3,
  hubspotSoftwareBoost: 2,
  levelsBoost: 1,
  weightProgressInProgress: 0.1,
  weightProgressCompleted: 1,
  includeRecencyDecay: true,
  includeUserProgress: true
};
export const useSearchRecencyScoringConfig = () => {
  const {
    experiments,
    experimentsLoading
  } = useExperiments();

  // gets experiment variation config from the variation name
  const experimentParams = experiments && experiments[experimentId] ? SearchRecencyConfigExperimentParams[experiments[experimentId].parameters.group] : null;
  return {
    scoringConfig: experimentParams ? Object.assign({}, baseConfiguration, experimentParams) : undefined,
    isLoadingSearchRecencyScoringConfig: experimentsLoading
  };
};